import React from 'react'
import styled from 'styled-components'
import SectionTitle from 'src/components/SectionTitle'
import { Input, Dropdown } from 'semantic-ui-react'
import InputWrapper from 'src/components/InputWrapper'
import { AppContext } from 'src/context/AppContext'

const selectOptions = [
  { key: 'am', value: 'am', text: '午前' },
  { key: 'pm', value: 'pm', text: '午後' }
]

const InputTime = () => (
  <AppContext.Consumer>
    {({ state, actions }) => {
      const hour = state.time.hour
      const minute = state.time.minute
      const hasHourError = hour === '' || hour < 0 || hour > 12
      const hasMinuteError = minute === '' || minute < 0 || minute > 59
      return (
        <InputWrapper>
          <SectionTitle>時間</SectionTitle>
          <div>
            <StyledDropdown
              name={'ampm'}
              selection
              options={selectOptions}
              placeholder={'Select AM or PM'}
              value={state.time.ampm}
              onChange={actions.onChangeInputTime}
            />
            <Input
              name={'hour'}
              type={'number'}
              placeholder={0}
              min={0}
              max={11}
              value={state.time.hour}
              onChange={actions.onChangeInputTime}
              error={state.submitted && hasHourError}
            />
            ：
            <Input
              name={'minute'}
              type={'number'}
              placeholder={0}
              min={0}
              max={59}
              value={state.time.minute}
              onChange={actions.onChangeInputTime}
              error={state.submitted && hasMinuteError}
            />
          </div>
        </InputWrapper>
      )
    }}
  </AppContext.Consumer>
)

export default InputTime

const StyledDropdown = styled(Dropdown)`
  && {
    margin-right: 12px;

    @media (max-width: 830px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
`
